var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tab_content"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.title)+"操作详情")]),_vm._v(" "),_c('span',[_vm._v("您所在的当前位置：首页 >> "+_vm._s(_vm.title)+"操作详情")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }